// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".home[data-v-57802784]{max-width:1150px;margin:auto}[data-v-57802784] .v-text-field__details{display:none}[data-v-57802784] .v-input__slot{margin:0}.card-temoin[data-v-57802784]{border:1px solid #ced9eb;-webkit-box-shadow:0 0 5px 0 #0000000d;box-shadow:0 0 5px 0 #0000000d}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
